export default {"src":"/_next/static/media/TastingPanel.f4f68d66.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};